export default __webpack_public_path__ + "static/media/three-dots.9d0fcda9.svg";